import React from "react";
import PropTypes from "prop-types";
import { SvgIcon } from "@mui/material";

export default function FeatureCard(props) {
  const { icon, text } = props.planFeature;

  return (
    <li>
      <div className={`icon-container background-color-16`}>
        <SvgIcon component={icon} color='primary' />
      </div>
      <div className="feature-card-text">
      {text}
      </div>
    </li>
  );
}

FeatureCard.propTypes ={
  planFeature: PropTypes.object.isRequired,
}
